'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OptionalItem = require('./OptionalItem');

var _OptionalItem2 = _interopRequireDefault(_OptionalItem);

var _BundlePage = require('../BundlePage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddOnItem(_ref) {
  var merchandiseId = _ref.merchandiseId;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var selectedAddOns = state.selectedAddOns;

  var onSelectedChange = (0, _react.useCallback)(function () {
    mergeState({
      selectedAddOns: selectedAddOns.includes(merchandiseId) ? selectedAddOns.delete(merchandiseId) : selectedAddOns.add(merchandiseId)
    });
  }, [mergeState, merchandiseId, selectedAddOns]);

  return _react2.default.createElement(_OptionalItem2.default, {
    selected: selectedAddOns.contains(merchandiseId),
    onSelectedChange: onSelectedChange,
    merchandiseId: merchandiseId
  });
}

exports.default = AddOnItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/optional-items/AddOnItem.js
// module id = 717
// module chunks = 3 4